jQuery(document).ready(function ($) {
  $(document).on('click', '.plus, .minus', function () {
    var qty = $(this).closest('.quantity').find('.qty')
    var val = parseFloat(qty.val())
    var max = parseFloat(qty.attr('max'))
    var min = parseFloat(qty.attr('min'))
    var step = parseFloat(qty.attr('step'))

    if ($(this).is('.plus')) {
      if (max && (max <= val)) return false
      qty.val(val + step).change()
    } else {
      if (min && (min >= val)) return false
      if (val > 1) {
        qty.val(val - step).change()
      }
    }
  })

  // if on cart page
  if ($('body').hasClass('single-product')) return

  $('body').on('change', 'input.qty', function () {
    $(this.form).append($('<input>').attr({
      type: 'hidden',
      name: 'update_cart',
      value: '1'
    })).submit()
  })
})

